const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.6914 16.2097C18.6914 16.2097 18.6914 16.1669 18.6914 16.0811C18.6914 15.9954 18.7374 15.9295 18.8295 15.8834H26.3729C25.6103 15.3098 25.1403 14.5747 24.9628 13.678C24.9628 13.6714 24.9628 13.6615 24.9628 13.6483C24.9628 13.6352 24.9595 13.6253 24.953 13.6187C24.953 13.5396 25.0088 13.5 25.1206 13.5H25.1502C25.2093 13.5 25.2488 13.5033 25.2685 13.5099C25.2882 13.5165 25.3079 13.5297 25.3277 13.5494C25.3474 13.5692 25.3573 13.5989 25.3573 13.6385C25.3573 13.678 25.3671 13.7308 25.3868 13.7967C25.4066 13.8626 25.4328 13.945 25.4657 14.0439C25.6103 14.4856 25.8503 14.8812 26.1856 15.2307C26.5208 15.5801 26.912 15.8273 27.359 15.9724C27.4181 15.9921 27.4477 16.0284 27.4477 16.0811C27.4477 16.1207 27.4313 16.1504 27.3984 16.1702C27.3655 16.1899 27.2867 16.2229 27.1618 16.269C27.0369 16.3152 26.912 16.3778 26.7871 16.4569C26.5175 16.6284 26.2842 16.8262 26.0869 17.0503C25.8897 17.2745 25.7418 17.4953 25.6432 17.7129C25.5446 17.9305 25.4756 18.0953 25.4361 18.2074C25.3967 18.3195 25.3704 18.4217 25.3573 18.514C25.3441 18.5799 25.3277 18.6194 25.3079 18.6326C25.2882 18.6458 25.2356 18.6557 25.1502 18.6623C25.0187 18.6623 24.953 18.626 24.953 18.5535C24.953 18.5074 24.9694 18.4249 25.0023 18.3063C25.2126 17.4756 25.6695 16.7998 26.3729 16.2789H18.8295C18.7374 16.2328 18.6914 16.1669 18.6914 16.0811V16.2097Z",
  fill: "#1E3F6B"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2.66797 16.2093C2.66797 16.2093 2.66797 16.1664 2.66797 16.0807C2.66797 15.995 2.80404 15.9291 3.07618 15.8829H20.0171C20.3086 15.9357 20.4544 16.0016 20.4544 16.0807C20.4544 16.1598 20.3086 16.2258 20.0171 16.2785H3.07618C2.80404 16.2324 2.66797 16.1664 2.66797 16.0807V16.2093Z",
  fill: "#1E3F6B"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.6914 16.0811C18.6914 16.1669 18.6914 16.2097 18.6914 16.2097V16.0811ZM18.6914 16.0811C18.6914 15.9954 18.7374 15.9295 18.8295 15.8834H26.3729C25.6103 15.3098 25.1403 14.5747 24.9628 13.678C24.9628 13.6714 24.9628 13.6615 24.9628 13.6483C24.9628 13.6352 24.9595 13.6253 24.953 13.6187C24.953 13.5396 25.0088 13.5 25.1206 13.5H25.1502C25.2093 13.5 25.2488 13.5033 25.2685 13.5099C25.2882 13.5165 25.3079 13.5297 25.3277 13.5494C25.3474 13.5692 25.3573 13.5989 25.3573 13.6385C25.3573 13.678 25.3671 13.7308 25.3868 13.7967C25.4066 13.8626 25.4329 13.945 25.4657 14.0439C25.6103 14.4856 25.8503 14.8812 26.1856 15.2307C26.5208 15.5801 26.912 15.8273 27.359 15.9724C27.4181 15.9921 27.4477 16.0284 27.4477 16.0811C27.4477 16.1207 27.4313 16.1504 27.3984 16.1702C27.3655 16.1899 27.2867 16.2229 27.1618 16.269C27.0369 16.3152 26.912 16.3778 26.7871 16.4569C26.5175 16.6284 26.2842 16.8262 26.0869 17.0503C25.8897 17.2745 25.7418 17.4953 25.6432 17.7129C25.5446 17.9305 25.4756 18.0953 25.4361 18.2074C25.3967 18.3195 25.3704 18.4217 25.3573 18.514C25.3441 18.5799 25.3277 18.6194 25.3079 18.6326C25.2882 18.6458 25.2356 18.6557 25.1502 18.6623C25.0187 18.6623 24.953 18.626 24.953 18.5535C24.953 18.5074 24.9694 18.4249 25.0023 18.3063C25.2126 17.4756 25.6695 16.7998 26.3729 16.2789H18.8295C18.7374 16.2328 18.6914 16.1669 18.6914 16.0811ZM2.66797 16.0807C2.66797 16.1664 2.66797 16.2093 2.66797 16.2093V16.0807ZM2.66797 16.0807C2.66797 15.995 2.80404 15.9291 3.07618 15.8829H20.0171C20.3086 15.9357 20.4544 16.0016 20.4544 16.0807C20.4544 16.1598 20.3086 16.2258 20.0171 16.2785H3.07618C2.80404 16.2324 2.66797 16.1664 2.66797 16.0807Z",
  stroke: "#1E3F6B",
  strokeWidth: 0.5
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 13 13)",
  stroke: "#0081CC"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 13 29)",
  stroke: "#0081CC"
});

const SvgEquationOperator3 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationOperator3, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-operator-3.c556d900.svg";
export { ForwardRef as ReactComponent };